// Profile dropdown options for Qbool matrimonial platform

export const EDUCATION_OPTIONS = [
  "No Formal Education",
  "Primary School",
  "Secondary / High School",
  "College Diploma",
  "Bachelor's Degree",
  "Master's Degree",
  "PhD / Doctorate",
  "Other"
];

export const ISLAMIC_EDUCATION_OPTIONS = [
  "None",
  "Islamic Studies (Aalim / Aalimah)",
  "Hifz-ul-Qur'an (Hafiz / Hafizah)",
  "Islamic Diploma / Certification",
  "Madrasa Education",
  "Other Islamic Studies"
];

export const JOB_CATEGORIES = {
  "Islamic & Religious": [
    "Imam / Khateeb",
    "Qur'an / Islamic Teacher",
    "Madrasa / Masjid Staff",
    "Islamic School Teacher",
    "Charity / Zakat Worker"
  ],
  "Education": [
    "School Teacher",
    "Lecturer / Professor",
    "Tutor",
    "Principal / Administrator"
  ],
  "Technology & IT": [
    "Software Engineer",
    "Web / App Developer",
    "IT Support",
    "Graphic Designer",
    "Digital Marketer"
  ],
  "Business & Finance": [
    "Accountant",
    "Office Administrator",
    "Business Manager",
    "Sales / Marketing",
    "Customer Service"
  ],
  "Healthcare": [
    "Doctor",
    "Nurse",
    "Therapist / Counselor",
    "Pharmacist"
  ],
  "Skilled Trades": [
    "Electrician",
    "Mechanic",
    "Carpenter",
    "Driver / Delivery"
  ],
  "Community & Social Work": [
    "Social Worker",
    "Youth Program Leader",
    "Volunteer Coordinator"
  ],
  "Creative & Media": [
    "Writer",
    "Photographer / Videographer",
    "Content Creator"
  ],
  "Other": [
    "Entrepreneur / Self-Employed",
    "Homemaker",
    "Student",
    "Unemployed"
  ]
};

export const MADHHAB_OPTIONS = [
  "Hanafi",
  "Maliki",
  "Shafi'i",
  "Hanbali",
  "Ahl-e-Hadith",
  "Salafi",
  "Ja'fari",
  "Zaydi",
  "Nizari Ismaili",
  "Musta'li Ismaili",
  "Tayyibi",
  "Dawoodi Bohra",
  "Sulaymani",
  "Alavi Bohra",
  "Ibadi",
  "Zahiri",
  "Awza'i",
  "Laythi",
  "Thawri",
  "Tabari (Jariri)",
  "Kufi School",
  "Ahl al-Madinah (Early Medinese School)",
  "Not Specific",
  "Other"
];

export const PRAYER_HABIT_OPTIONS = [
  "Always (5 times daily)",
  "Sometimes",
  "Rarely",
  "Learning"
];

export const BEARD_OPTIONS = [
  "Yes (Sunnah style)",
  "Yes (Trimmed)",
  "No",
  "Growing"
];

export const HIJAB_NIQAB_OPTIONS = [
  "Hijab",
  "Niqab",
  "Neither (Not yet)",
  "Planning to wear"
];

export const QURAN_RECITATION_OPTIONS = [
  "Basic (Can read)",
  "Intermediate (Regular reader)",
  "Advanced (Fluent with Tajweed)",
  "Hafiz/Hafizah (Memorized)"
];

export const RELIGIOUS_COMMITMENT_OPTIONS = [
  "Very Practicing",
  "Moderately Practicing",
  "Learning & Improving",
  "Liberal"
];

export const ISLAMIC_PRACTICES_OPTIONS = [
  "Strictly Practicing",
  "Moderately Practicing",
  "Casual Practicing",
  "Not Currently Practicing"
];

export const FAMILY_RELIGIOUS_LEVEL_OPTIONS = [
  "Very Practicing",
  "Moderately Practicing",
  "Liberal",
  "Mixed"
];

export const MARITAL_STATUS_OPTIONS = [
  "Never Married",
  "Divorced",
  "Widowed",
  "Separated"
];

export const LANGUAGE_OPTIONS = [
  "English",
  "Arabic",
  "Urdu",
  "Hindi",
  "Gujarati",
  "French",
  "Spanish",
  "Punjabi",
  "Bengali",
  "Somali",
  "Turkish",
  "Persian (Farsi)",
  "Pashto",
  "Malay",
  "Indonesian",
  "Swahili",
  "Hausa",
  "Kurdish",
  "Albanian",
  "Bosnian",
  "Tagalog",
  "Amharic",
  "Yoruba",
  "Dari",
  "Sindhi",
  "Tamil",
  "Telugu",
  "Kannada",
  "Malayalam",
  "Marathi",
  "Other"
];

export const CANADIAN_PROVINCES = [
  "Alberta",
  "British Columbia",
  "Manitoba",
  "New Brunswick",
  "Newfoundland and Labrador",
  "Northwest Territories",
  "Nova Scotia",
  "Nunavut",
  "Ontario",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
  "Yukon",
  "Other"
];

// Province abbreviation to full name mapping
export const PROVINCE_FULL_NAMES = {
  "AB": "Alberta",
  "BC": "British Columbia",
  "MB": "Manitoba",
  "NB": "New Brunswick",
  "NL": "Newfoundland and Labrador",
  "NT": "Northwest Territories",
  "NS": "Nova Scotia",
  "NU": "Nunavut",
  "ON": "Ontario",
  "PE": "Prince Edward Island",
  "QC": "Quebec",
  "SK": "Saskatchewan",
  "YT": "Yukon"
};


export const BUILD_OPTIONS = [
  "Slim",
  "Average",
  "Athletic",
  "Heavy"
];


export const INCOME_RANGES = [
  "0 - 20,000",
  "20,000 - 40,000",
  "40,000 - 60,000",
  "60,000 - 80,000",
  "80,000 - 100,000",
  "100,000 - 150,000",
  "150,000+",
  "Prefer Not to Say"
];

export const INCOME_PERIOD_OPTIONS = [
  { value: "yearly", label: "Yearly" },
  { value: "monthly", label: "Monthly" }
];

export const CURRENCY_OPTIONS = [
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "CAD", symbol: "C$", name: "Canadian Dollar" },
  { code: "GBP", symbol: "£", name: "British Pound" },
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "INR", symbol: "₹", name: "Indian Rupee" },
  { code: "PKR", symbol: "Rs", name: "Pakistani Rupee" },
  { code: "AED", symbol: "د.إ", name: "UAE Dirham" },
  { code: "SAR", symbol: "﷼", name: "Saudi Riyal" },
  { code: "AUD", symbol: "A$", name: "Australian Dollar" },
  { code: "MYR", symbol: "RM", name: "Malaysian Ringgit" },
  { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
  { code: "BDT", symbol: "৳", name: "Bangladeshi Taka" },
  { code: "IDR", symbol: "Rp", name: "Indonesian Rupiah" },
  { code: "TRY", symbol: "₺", name: "Turkish Lira" },
  { code: "ZAR", symbol: "R", name: "South African Rand" },
  { code: "NGN", symbol: "₦", name: "Nigerian Naira" },
  { code: "EGP", symbol: "E£", name: "Egyptian Pound" },
  { code: "KES", symbol: "KSh", name: "Kenyan Shilling" },
  { code: "OTHER", symbol: "", name: "Other" }
];

export const HEIGHT_OPTIONS = [
  "Under 5'0\"",
  "5'0\" - 5'2\"",
  "5'3\" - 5'5\"",
  "5'6\" - 5'8\"",
  "5'9\" - 5'11\"",
  "6'0\" - 6'2\"",
  "6'3\" and above"
];

// Get all job titles from categories

// Comprehensive Occupation List (General + Islamic)
export const OCCUPATION_OPTIONS = [
  // === ISLAMIC-RELATED OCCUPATIONS ===
  // Religious & Educational
  "Imam",
  "Mufti",
  "Qari (Qur'an reciter)",
  "Hafiz/Hafiza (memorizer of Qur'an)",
  "Islamic Studies Teacher",
  "Madrasa Teacher",
  "Sheikh/Scholar (Aalim)",
  "Lecturer in Islamic Studies",
  "Du'a/Khatib (Friday sermon speaker)",
  
  // Community & Social
  "Islamic Counselor",
  "Muslim Chaplain",
  "Community Center Manager (Masjid/Islamic Centre)",
  "Youth Program Coordinator",
  "Islamic School Principal",
  "Zakat Officer",
  "Halal Food Inspector",
  "Halal Auditor",
  "Masjid Administrator",
  
  // Charity & Humanitarian
  "NGO Worker",
  "Charity Organizer",
  "Relief Coordinator",
  "Fundraising Manager for Islamic Orgs",
  "Orphan Support Program Worker",
  
  // Creative Islamic Fields
  "Islamic Calligrapher",
  "Islamic Author",
  "Islamic Content Writer",
  "Nasheed Artist",
  "Islamic App Developer",
  "Islamic Website Designer",
  
  // Business (Islamic Focus)
  "Halal Business Owner",
  "Islamic Finance Expert",
  "Shariah Compliance Officer",
  "Islamic Banker",
  "Islamic Microfinance Officer",
  "Hajj & Umrah Travel Coordinator",
  
  // === GENERAL MODERN OCCUPATIONS ===
  // Technology
  "Software Developer",
  "Web Developer",
  "Mobile App Developer",
  "UI/UX Designer",
  "IT Support Specialist",
  "Network Administrator",
  "Cybersecurity Analyst",
  "Data Analyst",
  "AI/ML Engineer",
  
  // Business & Office
  "Accountant",
  "Bookkeeper",
  "Business Manager",
  "HR Specialist",
  "Customer Support",
  "Sales Representative",
  "Marketing Specialist",
  "Project Manager",
  "Office Administrator",
  
  // Education
  "Teacher",
  "Tutor",
  "School Principal",
  "Lecturer",
  "Researcher",
  "Education Consultant",
  
  // Healthcare
  "Doctor",
  "Nurse",
  "Pharmacist",
  "Dentist",
  "Physiotherapist",
  "Medical Assistant",
  "Healthcare Administrator",
  
  // Creative
  "Graphic Designer",
  "Photographer",
  "Videographer",
  "Content Creator",
  "Writer",
  "Editor",
  "Animator",
  "Fashion Designer",
  
  // Construction & Skilled Trades
  "Electrician",
  "Plumber",
  "Carpenter",
  "Welder",
  "Mechanic",
  "Driver",
  
  // Retail & Service
  "Cashier",
  "Store Manager",
  "Receptionist",
  "Waiter/Waitress",
  "Barista",
  "Delivery Worker",
  
  // Government & Public Services
  "Firefighter",
  "Police Officer",
  "Social Worker",
  "City Clerk",
  "Postal Worker",
  
  // Other
  "Other"
];


export const getAllJobTitles = () => {
  const allTitles = [];
  Object.keys(JOB_CATEGORIES).forEach(category => {
    allTitles.push(...JOB_CATEGORIES[category]);
  });
  return allTitles;
};

// Get category from job title
export const getCategoryFromJob = (jobTitle) => {
  for (const [category, jobs] of Object.entries(JOB_CATEGORIES)) {
    if (jobs.includes(jobTitle)) {
      return category;
    }
  }
  return "Other";
};
